// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2917":"22842887e57fa423","4044":"b89aa897295a918f","4515":"22842887e57fa423","4969":"88aa041cc9bbbd9a","5264":"d8cab1acad0336d3","8378":"d65128d68d028acc"}[chunkId] + ".css";
};